export default __webpack_public_path__ + "img/satelite-layer.png";